import { useState } from "react";
import { Container, Row, Col, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomButton from "../customButton/CustomButton";
import { FaCircleUser } from "react-icons/fa6";
import { MdBusinessCenter } from "react-icons/md";
import { HiMiniBuildingOffice2 } from "react-icons/hi2";
import logo from "../../../assets/images/logo.png";
import SignupLeftSideCard from "./SignupLeftSideCard";
import { MODE_DESCRIPTIONS } from "../content";

const SignupCard = () => {
    const [activeTab, setActiveTab] = useState("personal");

    const tabs = [
        { key: "personal", icon: FaCircleUser, label: "Personal", link: "/register/personal" },
        { key: "business", icon: MdBusinessCenter, label: "Business", link: "/register/business" },
        { key: "enterprise", icon: HiMiniBuildingOffice2, label: "Enterprise", link: "/register/enterprise" },
    ];

    return (
        <div className="min-vh-100">
            <Container fluid >
                <Row className="min-vh-100">
                    <Col
                        md={4}
                        className="d-none d-md-flex align-items-center justify-content-center text-white p-[10px]"
                    >
                        <SignupLeftSideCard />
                    </Col>

                    <Col xs={12} md={8} className="d-flex align-items-center justify-content-center" >
                        <div className="w-100" style={{ maxWidth: "600px" }}>
                            <div className="flex items-center mb-6">
                                <img
                                    className="img-thumbnail !border-none !max-w-[155px] md:!max-w-[178px]"
                                    src={logo}
                                    alt="logo"
                                />
                            </div>

                            <h3 className="text-2xl md:text-3xl lg:text-4xl font-medium mb-2">
                                Hi, Welcome to Datara
                            </h3>
                            <p className="text-muted text-sm md:text-base mb-8">
                                Dive right in by selecting your account type
                            </p>

                            <Card className="p-4 shadow-lg shadow-gray-500/50 !border-none !rounded-none w-full">
                                <Form>
                                    <div className="flex flex-col md:flex-row items-stretch justify-between gap-3">
                                        {tabs.map((tab) => (
                                            <label
                                                key={tab.key}
                                                className={`flex flex-1 items-center justify-center border-2 px-[17px] py-[13px] rounded-md cursor-pointer transition ${activeTab === tab.key
                                                    ? "bg-[#AEF46817] border-[#579B39]"
                                                    : "bg-white border-gray-300"
                                                    }`}
                                            >
                                                <input
                                                    type="radio"
                                                    name="signup-type"
                                                    value={tab.key}
                                                    checked={activeTab === tab.key}
                                                    onChange={() => setActiveTab(tab.key)}
                                                    className="hidden peer"
                                                />
                                                <span
                                                    className={`w-4 h-4 mr-2 rounded-full border ${activeTab === tab.key
                                                        ? "bg-[#44C523] border-[#579B39]"
                                                        : "border-gray-400"
                                                        }`}
                                                ></span>
                                                <span className="text-sm md:text-base">{tab.label}</span>
                                            </label>
                                        ))}
                                    </div>
                                </Form>

                                <div className="mt-[30px]">
                                    <span className="capitalize font-medium mb-1 text-lg">{activeTab + " Mode"}</span>
                                    <p className="text-muted text-xs md:text-sm lg:text-base">
                                       {MODE_DESCRIPTIONS[activeTab]?.description}
                                    </p>
                                </div>
                                <Link to={`/register/${activeTab}`} className="text-decoration-none block">
                                    <CustomButton
                                        className="w-full mt-3 !border-none !rounded-[4px] !text-black !font-bold !bg-[#AEF468]"
                                        type="button"
                                    >
                                        Sign Up
                                    </CustomButton>
                                </Link>
                                <div className="d-flex justify-content-between align-items-center gap-1">
                                    <Link className="w-100" to='/login'>
                                        <CustomButton
                                            className='w-100 login-btn mt-3 '
                                            type="button"
                                        >
                                            <span className="text-white text-decoration-none">
                                                Already have an account? Log-In
                                            </span>
                                        </CustomButton>
                                    </Link>

                                </div>
                            </Card>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default SignupCard;
